export default "__VITE_ASSET__a0b4b9e8__"